module.exports = __webpack_public_path__ + "img/mobile-55.c9795929.png";